<template>
  <div class="contact">
    <div class="contact__content">
      <div class="container">
        <div class="row" data-aos="fade-up">
          <div class="col-lg-6">
            <div class="contact__content-info">
              <div class="info__title">Register for consultations</div>
              <div class="info__image">
                <img src="/assets/images/layouts/contact-icon.png" alt="icon">
              </div>
              <div class="info__list">
                <div class="info__list-item">
                  <div class="item__title">Address</div>
                  <a href="https://www.google.com/maps/place/Timebird/@21.0295365,105.7836425,17z/data=!3m1!4b1!4m5!3m4!1s0x3135ab7df7fbe5c3:0xdcaaa0820fa0f671!8m2!3d21.0295315!4d105.7858312" class="item__text">3/1/82 Dich Vong Hau, Dich Vong Hau Ward, Cau Giay District, Hanoi City, Vietnam</a>
                </div>
                <div class="info__list-item">
                  <div class="item__title">Email</div>
                  <a href="mailto:contact@timebird.org" class="item__text">contact@timebird.org</a>
                </div>
                <div class="info__list-item">
                  <div class="item__title">Phone</div>
                  <a href="tel:+84366793899" class="item__text">+84 366 739 899</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="contact__content-form" :class="{'loading': isLoading}">
              <form @submit.prevent="sendEmail">
                <div class="form__input">
                  <label for="name">
                    <span>*</span>
                    Full name :
                  </label>
                  <input type="text" id="name" v-model="form.fullname" @input="isCheck(validate.fullname)">
                  <span>{{error.fullname}}</span>
                </div>
                <div class="form__input">
                  <label for="phone">
                    <span>*</span>
                    Phone :
                  </label>
                  <input type="number" id="phone" v-model="form.phone" @input="isCheck(validate.phone)" >
                  <span>{{error.phone}}</span>
                </div>
                <div class="form__input">
                  <label for="email">
                    <span>*</span>
                    Email :
                  </label>
                  <input type="email" id="email" v-model="form.email" @input="isCheck(validate.email)">
                  <span>{{error.email}}</span>
                </div>
                <div class="form__input">
                  <label for="message">
                    <span>*</span>
                    Message :
                  </label>
                  <textarea id="message" v-model="form.message" @input="isCheck(validate.message)"></textarea>
                  <span>{{error.message}}</span>
                </div>
                <div class="form__button">
                  <button type="submit" :disabled="isDisabled">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Notification } from 'element-ui'
import emailjs from 'emailjs-com'
export default {
  data() {
    return {
      isLoading: false,
      isDisabled: false,
      form: {
        fullname: '',
        phone: '',
        email: '',
        message: ''
      },
      error: {
        fullname: '',
        phone: '',
        email: '',
        message: ''
      },
      validate: {
        fullname: {
          key: 'fullname',
          label: 'Full name',
          regex: /^(?=.{5,25}$)[\S+]+(?:\s[\S+]+)*?$/,
          message:'Please enter from 5 to 25 characters. Do not enter leading, trailing spaces or too many spaces.'
        },
        phone: {
          key: 'phone',
          label: 'Phone',
          regex: /^\d{10,14}$/,
          message:'Please enter from 10 to 14 characters.'
        },
        email: {
          key: 'email',
          label: 'Email',
          regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
          message:'Please enter correct email format. Do not enter spaces.'
        },
        message: {
          key: 'message',
          label: 'Message',
          regex: /^/,
          message:'Message is required'
        },
      }
    }
  },
  computed: {
    isValidated() {
      return this.form.fullname !== ''
            && this.form.phone !== ''
            && this.form.email !== ''
            && this.form.message !== ''
            && this.error.fullname === '' 
            && this.error.phone === '' 
            && this.error.email === '' 
            && this.error.message === '' 
    }
  },
  methods: {
    isCheck({key, label, regex, message}) {
      if (this.form[key] === '') {
        this.isDisabled = true
        this.error[key] = `${label} is required`
      } else {
        if(regex.test(this.form[key].trim())) {
          this.error[key] = ''
          if(this.isValidated) {
            this.isDisabled = false
          }
        } else {
          this.error[key] = message
          this.isDisabled = true
        }
      }
    },
    sendEmail() {
      for (const key in this.validate) {
        if (Object.hasOwnProperty.call(this.validate, key)) {
          const _validate = this.validate[key];
          this.isCheck(_validate)
        }
      }
      if(!this.isValidated) return
      this.isLoading = true
      emailjs.send('service_bcihgps', 'template_xwxuqwq', this.form, 'user_lBGprrDgAQsKmpsoZj5n5').then((result) => {
        Notification.success({
          title: 'Success',
          message: 'Your email have been sent',
          duration: 2400 })
        this.isLoading = false
        this.form.fullname = this.form.phone = this.form.email = this.form.message = ''
      }, (error) => {
        this.isLoading = false
        this.$notify.error({
          title: 'Thất bại',
          message: 'Email chưa được gửi',
          duration: 2400
        })
      })
    }
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>
